export default "__VITE_ASSET__DIMZNSJj__"